import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import FastImage from 'react-native-fast-image';
import {css} from 'styled-components/native';

interface StepCircleStyle {
  status: 'editing' | 'done' | 'pending';
}

interface StepLineStyle {
  active: boolean;
  width?: string;
}

interface StepTextStyle {
  active: boolean;
  width?: number;
}

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
`;

export const InputGrid = styled.View`
  
  flex-direction: row;
  gap:${RFValue(12)}px;
  justify-content: space-between;
  align-items: center;
`;

export const Form = styled.View``;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const InputGroupGrid = styled.View`
  flex: 1;
`;

export const FlagContainer = styled.View``;

//@ts-ignore
export const Flag = styled(FastImage)`
  width: ${RFValue(22)}px;
  height: ${RFValue(15)}px;
  margin-right: ${RFValue(12)}px;
`;

export const PickerContainer = styled.View`

`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${RFValue(12)}px;
`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const Footer = styled.View`
  padding: 0 24px;

  width: 100%;
  
`;

export const Step = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding-bottom: ${RFValue(30)}px;
`;

export const LineStep = styled.View<StepLineStyle>`
  height: 4px;
  flex-grow: 1;
  margin: 0 4px;
  border-radius: 12px;
  ${({active}) =>
    css`
      background-color: ${({theme}) =>
        active ? theme.colors.primary : theme.colors.placeholder};
    `}
`;

export const LineStepSeparator = styled(LineStep)`
  width: 40px;
  flex-grow: 0;
`;

export const CircleStep = styled.View<StepCircleStyle>`
  height: 24px;
  width: 24px;
  border-radius: 12px;
  position: relative;
  ${({status, theme}) =>
    status === 'done' &&
    css`
      border-color: ${theme.colors.primary};
      border-width: 4px;
      background-color: ${theme.colors.primary};
    `}

  ${({status, theme}) =>
    status === 'editing' &&
    css`
      border-color: ${theme.colors.primary};
      border-width: 4px;
    `}

  ${({status, theme}) =>
    status === 'pending' &&
    css`
      border-color: ${theme.colors.placeholder};
      border-width: 4px;
    `}
`;

export const StepText = styled.Text<StepTextStyle>`
  position: absolute;


  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;

  ${({active, width = 100, theme}) =>
    css`
      width: ${width}px;
      left: -${width / 2 - 12}px;
      top: 24px;
      color: ${active ? theme.colors.primary : theme.colors.placeholder};
    `};
`;

export const List = styled.View`

`;
